
import { ClothingItem } from "../types";
import { inferSubcategory } from "./categoryUtils";

export const mapDbItemToClothingItem = (dbItem: any): ClothingItem => {
  // Initialize the images array
  let images = [];
  
  // Handle image_url from database - ensure it's always in the images array
  if (dbItem.image_url) {
    if (Array.isArray(dbItem.image_url)) {
      images = dbItem.image_url;
    } else {
      images = [dbItem.image_url];
    }
  }
  
  // Make sure lifestyle_tags is always an array
  const lifestyle_tags = Array.isArray(dbItem.lifestyle_tags)
    ? dbItem.lifestyle_tags
    : (dbItem.lifestyle_tags ? [dbItem.lifestyle_tags] : []);

  // Make sure dominant_hex_colors is always an array
  const dominant_hex_colors = Array.isArray(dbItem.dominant_hex_colors)
    ? dbItem.dominant_hex_colors
    : (dbItem.dominant_hex_colors ? [dbItem.dominant_hex_colors] : []);


  return {
    id: dbItem.id,
    name: dbItem.name,
    brand: dbItem.brand || "",
    color: dbItem.color || "",
    category: dbItem.category,
    subcategory: dbItem.subcategory ?? inferSubcategory(dbItem.name, dbItem.category) ?? undefined,
    subcategories: dbItem.subcategories || [],
    status: dbItem.status || "PURCHASED",
    storeUrl: dbItem.store_url || "",
    description: dbItem.description || "",
    images: images,
    user_id: dbItem.user_id,
    favorite: dbItem.favorite || false,
    lifestyle_tags: lifestyle_tags,
    dominant_hex_colors: dominant_hex_colors,
    created_at: dbItem.created_at,
    uploaded_by: dbItem.uploaded_by ?? null,
    processing_status: dbItem.processing_status || "ready",
    // The stylist's annotation, embedded by fetchUserClothingItems. RLS already hides
    // private notes from the customer; the filter here makes admin view-as match what
    // the customer sees. Left undefined when the fetch didn't ask for notes.
    clothing_audit_notes: Array.isArray(dbItem.clothing_audit_notes)
      ? dbItem.clothing_audit_notes.filter((n: any) => n && n.customer_visible !== false)
      : undefined,
  };
};

// Deliberately no uploaded_by here: a BEFORE INSERT trigger stamps it from
// auth.uid(), and a copied item must never carry a stale value.
export const mapClothingItemToDb = (item: Omit<ClothingItem, "id">, userId: string) => {
  // Ensure lifestyle_tags is properly formatted for db
  const lifestyle_tags = Array.isArray(item.lifestyle_tags)
    ? item.lifestyle_tags
    : (item.lifestyle_tags ? [item.lifestyle_tags] : []);

  // Ensure dominant_hex_colors is properly formatted for db
  const dominant_hex_colors = Array.isArray(item.dominant_hex_colors)
    ? item.dominant_hex_colors
    : (item.dominant_hex_colors ? [item.dominant_hex_colors] : []);


  return {
    name: item.name,
    brand: item.brand,
    color: item.color,
    category: item.category,
    subcategory: item.subcategory,
    subcategories: item.subcategories,
    status: item.status,
    store_url: item.storeUrl,
    description: item.description,
    image_url: item.images && item.images.length > 0 ? item.images[0] : "",
    user_id: userId,
    favorite: item.favorite || false,
    lifestyle_tags: lifestyle_tags,
    dominant_hex_colors: dominant_hex_colors
  };
};
